var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"next-run-cell"}},[(_vm.showTimeAgo)?_c('time-ago-tooltip',{attrs:{"time":_vm.realNextRunTime}}):_c('span',{attrs:{"data-testid":"pipeline-schedule-inactive"}},[_vm._v("\n    "+_vm._s(_vm.s__('PipelineSchedules|Inactive'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }